module.exports = __webpack_public_path__ + "static/media/17-skall.4e1e01b4.mp3";